import { Requests } from "./Requests"
import endpoints from '../../endpoints'

const WEB_APP_URL = endpoints.WEB_APP
// Matches the org dropdown's page size (organizationService's DEFAULT_ORG_PAGE_SIZE).
const HI_MARLEY_USERS_PAGE_SIZE = 50

export default class UserHelpers {

  /**
   * User by Email
   * @returns {Object}
   */
  static async getByEmail(email){
    if (!email) {
      console.error("No email provided to search on")
      return
    }
    const url = `${WEB_APP_URL}/api/user/email/${email}`
    const user = await Requests.authRequest(url, 'GET')
    return user
  }

  static async getAliasUsers(orgId){
    const params = new URLSearchParams({ organizationId: orgId })
    const url = `${WEB_APP_URL}/api/alias-operators?${params.toString()}`
    const aliasUsers = await Requests.authRequest(url, 'GET', null, true)
    return aliasUsers
  }

  // One page at a time - the full list 502s once an org is large enough.
  static async fetchHiMarleyUsersPage(search = '', page = 1){
    const params = new URLSearchParams({
      role: 'operator',
      status: 'active',
      sort: 'profile.firstName',
      order: 'ASC',
      limit: HI_MARLEY_USERS_PAGE_SIZE,
      page,
    })
    if (search) params.set('searchText', search)
    const url = `${WEB_APP_URL}/api/user/userlist?${params.toString()}`
    const response = await Requests.authRequest(url, 'GET')
    const users = response.users
    return { users, hasMore: users.length === HI_MARLEY_USERS_PAGE_SIZE }
  }

  static async createAliasUser(email, organizationId){
    const url = `${WEB_APP_URL}/api/alias-operators`
    const aliasUser = await Requests.authRequest(url, 'POST', { email, organizationId }, true)
    return aliasUser
  }

  static async reactivateAliasUser(aliasId, organizationId) {
    const url = `${WEB_APP_URL}/api/alias-operators/${aliasId}`
    const body = { organizationId }
    const activatedUser = await Requests.authRequest(url, 'PUT', body, true)
    return activatedUser
  }

  static async deactivateAliasUser(aliasId, organizationId) {
    const params = new URLSearchParams({ organizationId })
    const url = `${WEB_APP_URL}/api/alias-operators/${aliasId}?${params.toString()}`
    const deactivatedUser = await Requests.authRequest(url, 'DELETE', null, true)
    return deactivatedUser
  }
}